/**
 * Rule to check if the field is greater than or equal to a given value
 * 
 * Usage: min:1
 * 
 */
export default {
    name     : 'min',
    validate : (value, data, parameters) => value >= parameters[0],
    message  : (field, data, parameters) => `The field ${field} must be atleast ${parameters[0]}`
}